import { useQuery } from '@tanstack/react-query';
import { listExecutionTemplates, type ExecutionTemplateSummary } from '../../../services/executionService';
import { executionKeys } from '../keys';

export function useExecutionTemplates(organizationId?: string) {
  const query = useQuery<ExecutionTemplateSummary[], Error>({
    queryKey: executionKeys.templates(organizationId),
    enabled: Boolean(organizationId),
    staleTime: 30 * 1000,
    queryFn: () => listExecutionTemplates(organizationId!),
  });

  return {
    templates: query.data ?? [],
    isLoading: query.isPending,
    error: query.error ?? null,
    refetch: query.refetch,
  };
}
